module.exports = __webpack_public_path__ + "static/Laura-Gutierrez-8e273f72324d70716b6bc4bb8dad4875.png";